const CATEGORY_META = {
  event: { label: 'Info', tone: 'info' },
  general: { label: 'Update', tone: 'update' },
  benefit: { label: 'Request', tone: 'request' },
  dues: { label: 'Dues', tone: 'dues' },
  security: { label: 'Security', tone: 'security' },
};

const DEFAULT_CATEGORY_META = { label: 'Update', tone: 'update' };

const RELATIVE_TIME_UNITS = [
  { limit: 60, unit: 'second', divisor: 1 },
  { limit: 3600, unit: 'minute', divisor: 60 },
  { limit: 86400, unit: 'hour', divisor: 3600 },
  { limit: 604800, unit: 'day', divisor: 86400 },
  { limit: 2629800, unit: 'week', divisor: 604800 },
  { limit: 31557600, unit: 'month', divisor: 2629800 },
  { limit: Infinity, unit: 'year', divisor: 31557600 },
];

const RELATIVE_TIME_FORMATTER = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

export const getCategoryMeta = (category) => CATEGORY_META[category] ?? DEFAULT_CATEGORY_META;

export const formatRelativeTime = (value) => {
  if (!value) {
    return 'Just now';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return 'Just now';
  }
  const secondsDifference = Math.round((date.getTime() - Date.now()) / 1000);
  const absSeconds = Math.abs(secondsDifference);

  for (const { limit, unit, divisor } of RELATIVE_TIME_UNITS) {
    if (absSeconds < limit) {
      const delta = Math.round(secondsDifference / divisor);
      return RELATIVE_TIME_FORMATTER.format(delta, unit);
    }
  }

  return 'Just now';
};

export const resolveNotificationPath = (linkUrl) => {
  if (!linkUrl) {
    return '/notifications';
  }

  if (/^https?:\/\//i.test(linkUrl)) {
    return linkUrl;
  }

  const normalized = linkUrl.split('#')[0] || '/notifications';

  if (normalized.startsWith('/digital-id')) {
    return '/digital-id';
  }
  if (normalized.startsWith('/my-venue-bookings')) {
    return '/my-venue-bookings';
  }
  if (normalized.startsWith('/my-requests')) {
    return '/my-requests';
  }
  if (normalized.startsWith('/membership-status')) {
    if (normalized.includes('approved') || normalized.includes('active')) {
      return '/account';
    }
    if (normalized.includes('rejected')) {
      return '/account';
    }
    return '/complete-profile';
  }
  if (normalized.startsWith('/news/')) {
    return '/news';
  }
  if (normalized.startsWith('/venues')) {
    return '/venues';
  }

  return normalized || '/notifications';
};

export { CATEGORY_META, DEFAULT_CATEGORY_META };
